import { useSelector, shallowEqual } from 'react-redux';
import { TradeState } from '../../types/trade';

const useSelectedTrade = (tradeState: TradeState): number => {
  const selectedTrade = useSelector(
    state => state.ui.selectedTrades[tradeState],
    shallowEqual
  );

  return selectedTrade;
};

export default useSelectedTrade;
